
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'AlertScanFailureApplyDiscount',
  props: {
    failureApplyDiscount: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    }
  }
})
